exports.components = {
  "component---src-pages-index-mdx": () => import("./../../../src/pages/index.mdx" /* webpackChunkName: "component---src-pages-index-mdx" */),
  "component---src-pages-repositories-mdx": () => import("./../../../src/pages/repositories.mdx" /* webpackChunkName: "component---src-pages-repositories-mdx" */),
  "component---src-pages-topics-guide-mdx": () => import("./../../../src/pages/topics-guide.mdx" /* webpackChunkName: "component---src-pages-topics-guide-mdx" */),
  "component---src-pages-videos-mdx": () => import("./../../../src/pages/videos.mdx" /* webpackChunkName: "component---src-pages-videos-mdx" */)
}

